import React from 'react'

export default () => (
  <span
    style={{
      backgroundColor: '#1e87f0',
      width: 10,
      height: 10,
      display: 'inline-block',
      borderRadius: '50%',
      marginRight: 5,
    }}
  />
)
